module.exports = __webpack_public_path__ + "static/media/download.81ce4738.svg";